// @ts-nocheck
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as Types from "../../../__generated__/schema.graphql.types";
import {
  AppointmentServicesFragmentDoc,
  AppointmentInvoiceFragmentDoc,
} from "../../fragments/appointment/appointmentBasicInfo.graphql.types";
import { ClientDataFragmentDoc } from "../../fragments/client/clientData.graphql.types";

const defaultOptions = {} as const;
export type AppointmentBasicInfoQueryVariables = Types.Exact<{
  id: Types.Scalars["bigint"]["input"];
  medspaId: Types.Scalars["bigint"]["input"];
}>;

export type AppointmentBasicInfoQuery = {
  __typename?: "query_root";
  appointmentByPk?: {
    __typename?: "appointment";
    id: string;
    created: string;
    startTime?: string | null;
    endTime?: string | null;
    timeSpan: string;
    medspaId: string;
    isAppointmentTelehealth?: boolean | null;
    status: string;
    reviewStatus: string;
    followupAppointmentBooked: boolean;
    client?: {
      __typename?: "client";
      id: string;
      email: string;
      firstName: string;
      lastName: string;
      fullName?: string | null;
      phone: string;
      birthdate?: string | null;
      note: string;
      lastSentFormsAt?: string | null;
    } | null;
    provider: {
      __typename?: "user";
      id: string;
      fullName?: string | null;
      userMedspas: Array<{ __typename?: "userMedspa"; id: string }>;
    };
    appointmentServices: Array<{
      __typename?: "AppointmentService";
      id: string;
      price: string;
      providerId?: string | null;
      startTime?: string | null;
      endTime?: string | null;
      serviceMenuItemId: string;
      serviceMenuItem: {
        __typename?: "MedspaServiceMenuItem";
        id: string;
        name: string;
      };
      provider?: {
        __typename?: "userMedspa";
        id: string;
        color?: string | null;
        initials?: string | null;
        user: {
          __typename?: "user";
          id: string;
          firstName: string;
          lastName: string;
        };
      } | null;
    }>;
    invoice?: { __typename?: "invoice"; id: string; status: string } | null;
  } | null;
};

export type AppointmentBasicInfoByInvoiceIdQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars["bigint"]["input"];
  medspaId: Types.Scalars["bigint"]["input"];
}>;

export type AppointmentBasicInfoByInvoiceIdQuery = {
  __typename?: "query_root";
  invoiceByPk?: {
    __typename?: "invoice";
    id: string;
    appointment?: {
      __typename?: "appointment";
      id: string;
      created: string;
      startTime?: string | null;
      endTime?: string | null;
      timeSpan: string;
      medspaId: string;
      status: string;
      reviewStatus: string;
      followupAppointmentBooked: boolean;
      isAppointmentTelehealth?: boolean | null;
      client?: {
        __typename?: "client";
        id: string;
        email: string;
        firstName: string;
        lastName: string;
        fullName?: string | null;
        phone: string;
        birthdate?: string | null;
        note: string;
        lastSentFormsAt?: string | null;
      } | null;
      provider: {
        __typename?: "user";
        id: string;
        fullName?: string | null;
        userMedspas: Array<{ __typename?: "userMedspa"; id: string }>;
      };
      appointmentServices: Array<{
        __typename?: "AppointmentService";
        id: string;
        price: string;
        providerId?: string | null;
        startTime?: string | null;
        endTime?: string | null;
        serviceMenuItemId: string;
        serviceMenuItem: {
          __typename?: "MedspaServiceMenuItem";
          id: string;
          name: string;
        };
        provider?: {
          __typename?: "userMedspa";
          id: string;
          color?: string | null;
          initials?: string | null;
          user: {
            __typename?: "user";
            id: string;
            firstName: string;
            lastName: string;
          };
        } | null;
      }>;
      invoice?: { __typename?: "invoice"; id: string; status: string } | null;
    } | null;
  } | null;
};

export const AppointmentBasicInfoDocument = gql`
  query AppointmentBasicInfo($id: bigint!, $medspaId: bigint!) {
    appointmentByPk(id: $id) {
      id
      created
      startTime
      endTime
      timeSpan
      medspaId
      isAppointmentTelehealth
      status
      reviewStatus
      followupAppointmentBooked
      client {
        ...ClientData
      }
      provider {
        id
        fullName
        userMedspas(
          where: {
            featurePermissions: { codename: { _eq: "is_provider" } }
            medspaId: { _eq: $medspaId }
          }
        ) {
          id
        }
      }
      ...AppointmentServices
      ...AppointmentInvoice
    }
  }
  ${ClientDataFragmentDoc}
  ${AppointmentServicesFragmentDoc}
  ${AppointmentInvoiceFragmentDoc}
`;

/**
 * __useAppointmentBasicInfoQuery__
 *
 * To run a query within a React component, call `useAppointmentBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentBasicInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useAppointmentBasicInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    AppointmentBasicInfoQuery,
    AppointmentBasicInfoQueryVariables
  > &
    (
      | { variables: AppointmentBasicInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AppointmentBasicInfoQuery,
    AppointmentBasicInfoQueryVariables
  >(AppointmentBasicInfoDocument, options);
}
export function useAppointmentBasicInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AppointmentBasicInfoQuery,
    AppointmentBasicInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AppointmentBasicInfoQuery,
    AppointmentBasicInfoQueryVariables
  >(AppointmentBasicInfoDocument, options);
}
export function useAppointmentBasicInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AppointmentBasicInfoQuery,
        AppointmentBasicInfoQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AppointmentBasicInfoQuery,
    AppointmentBasicInfoQueryVariables
  >(AppointmentBasicInfoDocument, options);
}
export type AppointmentBasicInfoQueryHookResult = ReturnType<
  typeof useAppointmentBasicInfoQuery
>;
export type AppointmentBasicInfoLazyQueryHookResult = ReturnType<
  typeof useAppointmentBasicInfoLazyQuery
>;
export type AppointmentBasicInfoSuspenseQueryHookResult = ReturnType<
  typeof useAppointmentBasicInfoSuspenseQuery
>;
export type AppointmentBasicInfoQueryResult = Apollo.QueryResult<
  AppointmentBasicInfoQuery,
  AppointmentBasicInfoQueryVariables
>;
export const AppointmentBasicInfoByInvoiceIdDocument = gql`
  query AppointmentBasicInfoByInvoiceId(
    $invoiceId: bigint!
    $medspaId: bigint!
  ) {
    invoiceByPk(id: $invoiceId) {
      id
      appointment {
        id
        created
        startTime
        endTime
        timeSpan
        medspaId
        status
        reviewStatus
        followupAppointmentBooked
        isAppointmentTelehealth
        client {
          ...ClientData
        }
        provider {
          id
          fullName
          userMedspas(
            where: {
              featurePermissions: { codename: { _eq: "is_provider" } }
              medspaId: { _eq: $medspaId }
            }
          ) {
            id
          }
        }
        ...AppointmentServices
        ...AppointmentInvoice
      }
    }
  }
  ${ClientDataFragmentDoc}
  ${AppointmentServicesFragmentDoc}
  ${AppointmentInvoiceFragmentDoc}
`;

/**
 * __useAppointmentBasicInfoByInvoiceIdQuery__
 *
 * To run a query within a React component, call `useAppointmentBasicInfoByInvoiceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentBasicInfoByInvoiceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentBasicInfoByInvoiceIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useAppointmentBasicInfoByInvoiceIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    AppointmentBasicInfoByInvoiceIdQuery,
    AppointmentBasicInfoByInvoiceIdQueryVariables
  > &
    (
      | {
          variables: AppointmentBasicInfoByInvoiceIdQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AppointmentBasicInfoByInvoiceIdQuery,
    AppointmentBasicInfoByInvoiceIdQueryVariables
  >(AppointmentBasicInfoByInvoiceIdDocument, options);
}
export function useAppointmentBasicInfoByInvoiceIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AppointmentBasicInfoByInvoiceIdQuery,
    AppointmentBasicInfoByInvoiceIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AppointmentBasicInfoByInvoiceIdQuery,
    AppointmentBasicInfoByInvoiceIdQueryVariables
  >(AppointmentBasicInfoByInvoiceIdDocument, options);
}
export function useAppointmentBasicInfoByInvoiceIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AppointmentBasicInfoByInvoiceIdQuery,
        AppointmentBasicInfoByInvoiceIdQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AppointmentBasicInfoByInvoiceIdQuery,
    AppointmentBasicInfoByInvoiceIdQueryVariables
  >(AppointmentBasicInfoByInvoiceIdDocument, options);
}
export type AppointmentBasicInfoByInvoiceIdQueryHookResult = ReturnType<
  typeof useAppointmentBasicInfoByInvoiceIdQuery
>;
export type AppointmentBasicInfoByInvoiceIdLazyQueryHookResult = ReturnType<
  typeof useAppointmentBasicInfoByInvoiceIdLazyQuery
>;
export type AppointmentBasicInfoByInvoiceIdSuspenseQueryHookResult = ReturnType<
  typeof useAppointmentBasicInfoByInvoiceIdSuspenseQuery
>;
export type AppointmentBasicInfoByInvoiceIdQueryResult = Apollo.QueryResult<
  AppointmentBasicInfoByInvoiceIdQuery,
  AppointmentBasicInfoByInvoiceIdQueryVariables
>;
